export default __webpack_public_path__ + "static/clause-limitation-responsabilite-avocat-1e7c9b1a7fbea989ebf51f1a1cb9d18f.jpg";